/**
 * Consegna e montaggio (0047): i giorni di un lavoro e il link dell'avviso.
 * Le date sono stringhe «2026-11-16» sull'ora di Roma, come in `lib/crm.js`.
 */
import { piuGiorni } from "@/lib/crm";

/** Dal primo giorno, `quanti` giorni di lavoro: la domenica non si lavora, il sabato di solito no
 *  (Aleandro, 30-10: si sceglie a mano) e un giorno saltato si scavalca (il lavoro si allunga di uno).
 *  `toccati` sono i giorni cambiati a mano: un feriale toccato si salta, un sabato toccato si lavora.
 *  Dà ogni giorno della finestra con lo stato che ha, così la schermata può mostrare anche quelli saltati. */
export function giorniDelLavoro(inizio, quanti, toccati = new Set()) {
  const finestra = [];
  let scelti = 0;
  for (let i = 0; scelti < quanti && i < 60; i++) {
    const giorno = piuGiorni(inizio, i);
    const giornoSettimana = new Date(`${giorno}T12:00:00Z`).getUTCDay();
    const saltato = giornoSettimana === 6 ? !toccati.has(giorno) : toccati.has(giorno);
    const stato = giornoSettimana === 0 ? "domenica" : saltato ? "saltato" : "scelto";
    if (stato === "scelto") scelti += 1;
    finestra.push({ giorno, stato });
  }
  return finestra;
}

/** Il primo giorno proposto: il lunedì della settimana di arrivo, se non è già passato; se no, domani. */
export function primoGiornoProposto(arrivo, oggi) {
  return arrivo && arrivo >= oggi ? arrivo : piuGiorni(oggi, 1);
}

/** Il link di WhatsApp col messaggio già scritto: `wa.me` vuole il numero solo in cifre, col prefisso. */
export function linkAvviso(telefonoE164, testo) {
  const cifre = String(telefonoE164 || "").replace(/\D/g, "");
  return cifre ? `https://wa.me/${cifre}?text=${encodeURIComponent(testo)}` : null;
}
